import { render } from "./MyDrawer.vue?vue&type=template&id=9416ba04&scoped=true"
import script from "./MyDrawer.vue?vue&type=script&lang=js"
export * from "./MyDrawer.vue?vue&type=script&lang=js"

import "./MyDrawer.vue?vue&type=style&index=0&id=9416ba04&scoped=true&lang=scss"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9416ba04"]])

export default __exports__